// Local development configuration with BFF mode enabled
// This mirrors production behavior where all API calls go through Cobra BFF
// BFF handles OAuth2 authentication and adds JWT tokens to API requests

import packageJson from '../../../package.json';

// Use same-origin for all API calls - Cobra BFF handles auth
const baseUrl = `${window.location.origin}`;

window.CKEDITOR_BASEPATH = '/ckeditor/';
window.CKFINDER_BASEPATH = '/ckfinder/';

export default {
  api: {
    baseUrl,
    authorization: '', // No API key needed - Cobra handles auth via OAuth2/JWT
    enableBFF: true,   // Enable BFF mode - all /api/* calls go through Cobra
  },
  assetUrl: '{{SANDCASTLE_CDN}}',
  assetPath: '/assets/images/',
  assetJsPath: '/assets/js/',
  slideTemplatePath: '/content/media/slideTemplate/images/',
  learningModuleTemplatePath: `/assets/learning_module_template/`,
  baseName: '',
  ckFinderConnectorPath: `${baseUrl}/ckfc/ckfinder/connector`,
  getManifestURL: `${baseUrl}/get-manifest`,
  getNavigationURL: `${baseUrl}/bff/navigation`,
  getUserInfoURL: `${baseUrl}/bff/user`,
  getTokenURL: `${baseUrl}/oauth2-client/auth/check-token`,
  isAPMEnabled: false,
  launchDarklyClientSideId: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID,
  OldCBTOKEN: 'd27cfd44d40d37576bbdfefa8ef30556',
  OldCBURL: 'https://lcms.dev.elmodev.com',
  NextMenuUrl: '/assets/js/menuNext.js',
};
